import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ActivatedRoute } from '@angular/router';

import { PortalApiService } from '../../portal-api.service';
import { PortalAuthService } from '../../portal-auth.service';
import { portalDate } from '../../shared/portal-format';

@Component({
	selector: 'portal-documents',
	templateUrl: './documents.component.html',
	styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent implements OnInit, OnDestroy {

	private sub?: Subscription;

	projectId!: string;
	loading = true;
	error = '';

	documents: any[] = [];
	sections: string[] = [];

	constructor(
		private route: ActivatedRoute,
		private api: PortalApiService,
		private auth: PortalAuthService
	) {}

	ngOnInit(): void {
		// Subscribed rather than read once from the snapshot: Angular reuses this
		// component when only the :id changes, so switching project (from the
		// activity feed, or with the browser's back button) would otherwise leave
		// the previous project's content on screen.
		this.sub = this.route.params.subscribe(params => {
			this.projectId = params['id'] || '';
			this.load();
		});
	}

	ngOnDestroy(): void {
		this.sub?.unsubscribe();
	}

	load(): void {
		this.loading = true;
		this.error = '';
		this.api.project.documents(this.projectId, (res: any) => {
			this.documents = res?.documents || [];
			this.sections = res?.sections || [];
			this.loading = false;
		}, (err: any) => {
			this.loading = false;
			if (err?.status === 401) { this.auth.goToLogin(); return; }
			this.error = err?.message || 'Could not load documents.';
		});
	}

	// Format the "added on" datetime. Backend sends a MySQL 'YYYY-MM-DD HH:MM:SS'
	// string; swap the space for 'T' so Angular's formatDate parses it reliably.
	when(value: string): string {
		if (!value) return '';
		return portalDate(('' + value).replace(' ', 'T'), 'd MMM y, HH:mm');
	}

	openDocument(d) {
		if(d.url) window.open(d.url, '_blank');
	}
}
